import React, { useContext, useEffect, useState } from "react";
import IDDropdown from "../generic/IDDropdown"; // A generic dropdown component
import { fetchMaterialTypes } from "../../services/MaterialAPI";
import { UserContext } from "../../context/UserContext";
import { Messages } from "../../constants/Messages";

interface MaterialTypeOption {
    id: number;
    material_type: string;
}

interface MaterialTypeDropdownProps {
    value: number | null; // The current selected material type ID
    onChange: (value: number | null) => void; // Callback for when the value changes
    refreshKey?: number; // Key to trigger re-fetching of material types
    required?: boolean; // Whether the dropdown is required
}

const MaterialTypeDropdown: React.FC<MaterialTypeDropdownProps> = ({
                                                                       value,
                                                                       onChange,
                                                                       refreshKey,
                                                                       required = true,
                                                                   }) => {
    const [ options, setOptions ] = useState<MaterialTypeOption[]>([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState<string | null>(null);
    const { isLoggedIn } = useContext(UserContext);


    useEffect(() => {
        if (isLoggedIn) {
            setError(null);
        }
        const loadMaterialTypes = async () => {
            setLoading(true);
            setError(null);

            try {
                const materialTypes = await fetchMaterialTypes();
                setOptions(materialTypes);
            } catch (err) {
                setError(Messages.ERROR_LOAD_MATERIALS);
            } finally {
                setLoading(false);
            }
        };

        loadMaterialTypes();
    }, [ refreshKey, isLoggedIn ]); // Re-fetch whenever refreshKey changes

    return (
        <div>
            <IDDropdown
                label="Material Type"
                options={options.map((opt) => ({
                    value: opt.id,
                    label: opt.material_type,
                }))}
                selectedValue={value} // Current value
                onChange={onChange} // Pass selected value to parent
                loading={loading}
                placeholder="Select a material type"
                required={required}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default MaterialTypeDropdown;
